export default __webpack_public_path__ + "static/media/icon_things-to-do.156a3320.svg";